export const apiVersionPrefix = "/api/v1";
export const homesPrefix = `${apiVersionPrefix}/homes`;
export const addMainGuestApi: string = `${homesPrefix}/addMainGuest`;
